/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TagsRouteImport } from './routes/tags'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SampleDataRouteImport } from './routes/sample-data'
import { Route as PlanningDetailRouteImport } from './routes/planning-detail'
import { Route as PermitDetailRouteImport } from './routes/permit-detail'
import { Route as ParcelMapRouteImport } from './routes/parcel-map'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ExploreRouteImport } from './routes/explore'
import { Route as DataDictionaryRouteImport } from './routes/data-dictionary'
import { Route as CoverageRouteImport } from './routes/coverage'
import { Route as ContractorDetailRouteImport } from './routes/contractor-detail'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminActivityRouteImport } from './routes/admin/activity'
import { Route as AddressSlugRouteImport } from './routes/address.$slug'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const TagsRoute = TagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SampleDataRoute = SampleDataRouteImport.update({
  id: '/sample-data',
  path: '/sample-data',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanningDetailRoute = PlanningDetailRouteImport.update({
  id: '/planning-detail',
  path: '/planning-detail',
  getParentRoute: () => rootRouteImport,
} as any)
const PermitDetailRoute = PermitDetailRouteImport.update({
  id: '/permit-detail',
  path: '/permit-detail',
  getParentRoute: () => rootRouteImport,
} as any)
const ParcelMapRoute = ParcelMapRouteImport.update({
  id: '/parcel-map',
  path: '/parcel-map',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreRoute = ExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => rootRouteImport,
} as any)
const DataDictionaryRoute = DataDictionaryRouteImport.update({
  id: '/data-dictionary',
  path: '/data-dictionary',
  getParentRoute: () => rootRouteImport,
} as any)
const CoverageRoute = CoverageRouteImport.update({
  id: '/coverage',
  path: '/coverage',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractorDetailRoute = ContractorDetailRouteImport.update({
  id: '/contractor-detail',
  path: '/contractor-detail',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminActivityRoute = AdminActivityRouteImport.update({
  id: '/admin/activity',
  path: '/admin/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const AddressSlugRoute = AddressSlugRouteImport.update({
  id: '/address/$slug',
  path: '/address/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/contractor-detail': typeof ContractorDetailRoute
  '/coverage': typeof CoverageRoute
  '/data-dictionary': typeof DataDictionaryRoute
  '/explore': typeof ExploreRoute
  '/login': typeof LoginRoute
  '/parcel-map': typeof ParcelMapRoute
  '/permit-detail': typeof PermitDetailRoute
  '/planning-detail': typeof PlanningDetailRoute
  '/sample-data': typeof SampleDataRoute
  '/search': typeof SearchRoute
  '/tags': typeof TagsRoute
  '/terms': typeof TermsRoute
  '/address/$slug': typeof AddressSlugRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/verify': typeof AuthVerifyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contractor-detail': typeof ContractorDetailRoute
  '/coverage': typeof CoverageRoute
  '/data-dictionary': typeof DataDictionaryRoute
  '/explore': typeof ExploreRoute
  '/login': typeof LoginRoute
  '/parcel-map': typeof ParcelMapRoute
  '/permit-detail': typeof PermitDetailRoute
  '/planning-detail': typeof PlanningDetailRoute
  '/sample-data': typeof SampleDataRoute
  '/search': typeof SearchRoute
  '/tags': typeof TagsRoute
  '/terms': typeof TermsRoute
  '/address/$slug': typeof AddressSlugRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/verify': typeof AuthVerifyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/contractor-detail': typeof ContractorDetailRoute
  '/coverage': typeof CoverageRoute
  '/data-dictionary': typeof DataDictionaryRoute
  '/explore': typeof ExploreRoute
  '/login': typeof LoginRoute
  '/parcel-map': typeof ParcelMapRoute
  '/permit-detail': typeof PermitDetailRoute
  '/planning-detail': typeof PlanningDetailRoute
  '/sample-data': typeof SampleDataRoute
  '/search': typeof SearchRoute
  '/tags': typeof TagsRoute
  '/terms': typeof TermsRoute
  '/address/$slug': typeof AddressSlugRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/verify': typeof AuthVerifyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contractor-detail'
    | '/coverage'
    | '/data-dictionary'
    | '/explore'
    | '/login'
    | '/parcel-map'
    | '/permit-detail'
    | '/planning-detail'
    | '/sample-data'
    | '/search'
    | '/tags'
    | '/terms'
    | '/address/$slug'
    | '/admin/activity'
    | '/admin/users'
    | '/auth/verify'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contractor-detail'
    | '/coverage'
    | '/data-dictionary'
    | '/explore'
    | '/login'
    | '/parcel-map'
    | '/permit-detail'
    | '/planning-detail'
    | '/sample-data'
    | '/search'
    | '/tags'
    | '/terms'
    | '/address/$slug'
    | '/admin/activity'
    | '/admin/users'
    | '/auth/verify'
  id:
    | '__root__'
    | '/'
    | '/contractor-detail'
    | '/coverage'
    | '/data-dictionary'
    | '/explore'
    | '/login'
    | '/parcel-map'
    | '/permit-detail'
    | '/planning-detail'
    | '/sample-data'
    | '/search'
    | '/tags'
    | '/terms'
    | '/address/$slug'
    | '/admin/activity'
    | '/admin/users'
    | '/auth/verify'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ContractorDetailRoute: typeof ContractorDetailRoute
  CoverageRoute: typeof CoverageRoute
  DataDictionaryRoute: typeof DataDictionaryRoute
  ExploreRoute: typeof ExploreRoute
  LoginRoute: typeof LoginRoute
  ParcelMapRoute: typeof ParcelMapRoute
  PermitDetailRoute: typeof PermitDetailRoute
  PlanningDetailRoute: typeof PlanningDetailRoute
  SampleDataRoute: typeof SampleDataRoute
  SearchRoute: typeof SearchRoute
  TagsRoute: typeof TagsRoute
  TermsRoute: typeof TermsRoute
  AddressSlugRoute: typeof AddressSlugRoute
  AdminActivityRoute: typeof AdminActivityRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tags': {
      id: '/tags'
      path: '/tags'
      fullPath: '/tags'
      preLoaderRoute: typeof TagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sample-data': {
      id: '/sample-data'
      path: '/sample-data'
      fullPath: '/sample-data'
      preLoaderRoute: typeof SampleDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/planning-detail': {
      id: '/planning-detail'
      path: '/planning-detail'
      fullPath: '/planning-detail'
      preLoaderRoute: typeof PlanningDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/permit-detail': {
      id: '/permit-detail'
      path: '/permit-detail'
      fullPath: '/permit-detail'
      preLoaderRoute: typeof PermitDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parcel-map': {
      id: '/parcel-map'
      path: '/parcel-map'
      fullPath: '/parcel-map'
      preLoaderRoute: typeof ParcelMapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore': {
      id: '/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof ExploreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-dictionary': {
      id: '/data-dictionary'
      path: '/data-dictionary'
      fullPath: '/data-dictionary'
      preLoaderRoute: typeof DataDictionaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coverage': {
      id: '/coverage'
      path: '/coverage'
      fullPath: '/coverage'
      preLoaderRoute: typeof CoverageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contractor-detail': {
      id: '/contractor-detail'
      path: '/contractor-detail'
      fullPath: '/contractor-detail'
      preLoaderRoute: typeof ContractorDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/activity': {
      id: '/admin/activity'
      path: '/admin/activity'
      fullPath: '/admin/activity'
      preLoaderRoute: typeof AdminActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/address/$slug': {
      id: '/address/$slug'
      path: '/address/$slug'
      fullPath: '/address/$slug'
      preLoaderRoute: typeof AddressSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ContractorDetailRoute: ContractorDetailRoute,
  CoverageRoute: CoverageRoute,
  DataDictionaryRoute: DataDictionaryRoute,
  ExploreRoute: ExploreRoute,
  LoginRoute: LoginRoute,
  ParcelMapRoute: ParcelMapRoute,
  PermitDetailRoute: PermitDetailRoute,
  PlanningDetailRoute: PlanningDetailRoute,
  SampleDataRoute: SampleDataRoute,
  SearchRoute: SearchRoute,
  TagsRoute: TagsRoute,
  TermsRoute: TermsRoute,
  AddressSlugRoute: AddressSlugRoute,
  AdminActivityRoute: AdminActivityRoute,
  AdminUsersRoute: AdminUsersRoute,
  AuthVerifyRoute: AuthVerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
